import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  FormGroupDirective,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { IDynamicFormField } from './dynamic-form-heplers/dynamic-form-vm';
import { InvalidErrorStateMatcher } from '../../utils/errorstate-matcher';
import { DynamicFormChildComponent } from './dynamic-form-child/dynamic-form-child.component';

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  providers: [FormGroupDirective],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, ReactiveFormsModule, DynamicFormChildComponent],
})
export class DynamicFormComponent implements OnInit {
  @Input() public form!: UntypedFormGroup;
  @Input() public dynamicFormFields!: IDynamicFormField[];
  @Input() public errorState: InvalidErrorStateMatcher;

  public ngOnInit(): void {
    this.dynamicFormFields.forEach((item) => {
      const control = new UntypedFormControl({ value: item.value || '', disabled: item.disabled }, item.validators || []);
      if (Object.keys(this.form?.controls).includes(item.id)) {
        this.form.setControl(item.id, control);
      } else {
        this.form.addControl(item.id, control);
      }
      this.form.updateValueAndValidity();
    });
  }
}
